export default __webpack_public_path__ + "static/media/dr-murillo.6c1131d4.webp";